import '@toast-ui/editor/dist/toastui-editor.css';
import { Editor } from '@toast-ui/react-editor';
import { useRef } from 'react';
import {
  Container,
  Form,
  Button,
  Table,
  Col,
  Pagination,
} from 'react-bootstrap';
import { useEffect, useState } from 'react';
import axios from 'axios';
import dateString from '../subpages/Notice';
import { root_url } from '../setting';
const TextTest = ({ history }) => {
  const [noticeList, setNoticeList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${root_url}/api/notice`);
        console.log('noticeData ===> ', data);
        setNoticeList(data);
        //console.log(modalData);
        setIsLoading(false);
      } catch (e) {
        console.log(e);
        alert(
          '시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)'
        );
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <Container>
      <h1 id="outline" className="mt-5 pt-3 text-center">
        공지사항
      </h1>
      <Table size="sm" bordered hover className="mt-5">
        <thead>
          <tr className="bg-custom-color text-white">
            <th style={{ width: '7%' }}>번호</th>
            <th>제목</th>
            <th style={{ width: '10%' }}>작성자</th>
            <th style={{ width: '20%' }}>날짜</th>
            <th style={{ width: '7%' }}>조회수</th>
            <th style={{ width: '10%' }}>팝업시작일</th>
            <th style={{ width: '10%' }}>팝업종료일</th>
          </tr>
        </thead>
        <tbody>
          {noticeList.length === 0 && (
            <tr>
              <td colSpan="5">게시물이 존재하지 않습니다.</td>
            </tr>
          )}
          {noticeList.map((post, index) => {
            return (
              <tr
                key={index}
                className="cursor-pointer"
                onClick={() => history.push(`notice/${post.postNo}`)}
              >
                <td className="smaller-in-md">{post.title}</td>
                <td className="text-truncate">{post.author}</td>
                <td className="text-truncate">
                  {dateString(new Date(post.createTime))}
                </td>
                <td className="text-truncate">
                  {dateString(new Date(post.createTime))}
                </td>
                <td>{post.viewCount === null ? '0' : post.viewCount}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      <Col
        lg={{ span: 2, offset: 10 }}
        className="bg-custom-color cursor-pointer text-white text-center rounded-pill p-1"
      >
        공지 작성하기
      </Col>
      <Pagination className="d-flex justify-content-center">
        <Pagination.First />
        <Pagination.Prev />
        <Pagination.Item active>{1}</Pagination.Item>
        <Pagination.Item>{2}</Pagination.Item>
        <Pagination.Item>{3}</Pagination.Item>
        <Pagination.Item>{4}</Pagination.Item>
        <Pagination.Next />
        <Pagination.Last />
      </Pagination>
    </Container>
  );
};
export default TextTest;

const Textarea = () => {
  const editorRef = useRef();
  const handleSubmit = () => {
    const editorInstance = editorRef.current.getInstance();
    const html = editorInstance.getHTML();
    console.log(html);
  };
  return (
    <div style={{ marginTop: `10rem` }}>
      <Editor
        usageStatistics={false}
        initialEditType="wysiwyg"
        ref={editorRef}
      />
      <button onClick={handleSubmit}>click</button>
    </div>
  );
};
